import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const DATE_FORMAT = 'DD.MM.YYYY';
export const BERLIN_TIMEZONE = 'Europe/Berlin';

export const dateToSave = (date = new Date()) => new Date(date.setUTCHours(2, 0, 0, 0)).toISOString();
export const dateToDisplay = (timestamp: number) => dayjs(timestamp).utc(true).format(DATE_FORMAT);
// dayjs.utc(timestamp).format(DATE_FORMAT);
export const dateCompare = (date: Date, timestamp: number) => (
  dayjs(date.setUTCHours(2, 0, 0, 0)).format(DATE_FORMAT)
    === dateToDisplay(new Date(timestamp).setUTCHours(24, 0, 0, 0))
);

export const toBerlinStartOfDayISO = (date: dayjs.ConfigType): string => (
  dayjs.tz(dayjs(date).format('YYYY-MM-DD'), BERLIN_TIMEZONE).startOf('day').toISOString()
);

export const toBerlinEndOfDayISO = (date: dayjs.ConfigType): string => (
  dayjs.tz(dayjs(date).format('YYYY-MM-DD'), BERLIN_TIMEZONE).endOf('day').toISOString()
);

export const fromBerlinISO = (iso: dayjs.ConfigType) => dayjs(iso).tz(BERLIN_TIMEZONE);
